"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
var messages_1 = require("./messages");
var kendo_react_intl_1 = require("@progress/kendo-react-intl");
/**
 * Represents the KendoReact Label component.
 * @example
 * ```jsx
 * const sizes = ["X-Small", "Small", "Medium", "Large", "X-Large", "2X-Large"];
 * const App = () => {
 *     const ddlRef = React.useRef(null);
 *     const labelId = 'ddl-sizes-label';
 *     const editorId = 'ddl-sizes';
 *
 *     return (
 *         <div>
 *             <Label id={labelId} editorId={editorId} editorRef={ddlRef}>
 *                 Shirt Size:
 *             </Label>
 *             <DropDownList
 *                 ref={ddlRef}
 *                 id={editorId}
 *                 ariaLabelledBy={labelId}
 *                 data={sizes}
 *             />
 *             <br />
 *         </div>
 *     );
 * };
 *
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
exports.Label = function (props) {
    var id = props.id, editorId = props.editorId, editorRef = props.editorRef, editorDisabled = props.editorDisabled, children = props.children, editorValid = props.editorValid, style = props.style, className = props.className, optional = props.optional;
    var localizationService = kendo_react_intl_1.useLocalization();
    var localizedOptional = optional ? localizationService
        .toLanguageString(messages_1.labelsOptional, messages_1.messages[messages_1.labelsOptional]) : '';
    var optionalElement = localizedOptional && (React.createElement("span", { className: 'k-label-optional' }, localizedOptional));
    var onLabelClick = React.useCallback(function (e) {
        if (editorRef && editorRef.current && !editorDisabled) {
            if (editorRef.current.focus) {
                e.preventDefault();
                editorRef.current.focus();
            }
            var editorActionElement = editorRef.current.actionElement;
            if (editorActionElement) {
                e.preventDefault();
                editorActionElement.click();
            }
        }
    }, [editorRef]);
    var labelClassName = kendo_react_common_1.classNames({
        'k-label': true,
        'k-label-empty': !children,
        'k-text-error': editorValid === false,
        'k-text-disabled': editorDisabled === true
    }, className);
    return (React.createElement("label", { id: id, htmlFor: editorId, onClick: onLabelClick, style: style, className: labelClassName },
        children,
        optionalElement));
};
exports.Label.propTypes = {
    id: PropTypes.string,
    editorId: PropTypes.string,
    editorRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    editorValid: PropTypes.bool,
    editorDisabled: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    optional: PropTypes.bool
};
exports.Label.displayName = 'KendoReactLabel';
//# sourceMappingURL=Label.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-labels@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react_nyscn3hbomdbkpk4tysqx62gaa/~/@progress/kendo-react-labels/dist/npm/Label.js
// module id = 6617
// module chunks = 0